var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00586 7.13867C6.15039 7.13477 6.28516 7.10547 6.41016 7.05078C6.53516 6.99609 6.65625 6.91016 6.77344 6.79297L11.1035 2.35742C11.2793 2.18164 11.3672 1.9668 11.3672 1.71289C11.3672 1.53711 11.3242 1.37891 11.2383 1.23828C11.1562 1.09375 11.0449 0.980469 10.9043 0.898438C10.7637 0.8125 10.6074 0.769531 10.4355 0.769531C10.1777 0.769531 9.94922 0.869141 9.75 1.06836L5.77148 5.17578H6.24609L2.25586 1.06836C2.05664 0.869141 1.82617 0.769531 1.56445 0.769531C1.39258 0.769531 1.23633 0.8125 1.0957 0.898438C0.955078 0.980469 0.841797 1.09375 0.755859 1.23828C0.673828 1.37891 0.632812 1.53711 0.632812 1.71289C0.632812 1.83789 0.654297 1.95508 0.697266 2.06445C0.744141 2.16992 0.810547 2.26758 0.896484 2.35742L5.23242 6.79297C5.4668 7.02344 5.72461 7.13867 6.00586 7.13867Z",
    fill: "#031723"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevronDown.2fbee239e172e4e3b189d9dcbf133104.svg";
export { ForwardRef as ReactComponent };